export default "__VITE_ASSET__Rzs$ZQa9__"